import { Grid } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import _ from "lodash";
import { getCountries } from "reduxState/settings/settings";
import { VariableGroupsDropdown } from "./VariableGroupsDropdown/VariableGroupsDropdown";
import { useStyles } from "./styles";

export function CountryDropdown({
  fieldName,
  isAchievementForm,
}: {
  fieldName: string;
  isAchievementForm?: boolean;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const { values, setFieldValue } = useFormikContext<any>();
  const countriesList = useAppSelector(getCountries);

  const value = _.get(values, fieldName);

  return (
    <>
      <Grid item xs={6}>
        <SelectInput
          className={classes.input}
          width="100%"
          data-test-id="condition-operator"
          items={[
            {
              id: "is_not_one_of",
              label: message({ id: "is_not_one_of" }),
            },
            {
              id: "is_one_of",
              label: message({ id: "is_one_of" }),
            },
            ...(isAchievementForm
              ? []
              : [
                  {
                    id: "is_one_of_group_values",
                    label: message({ id: "is_one_of_collections" }),
                  },
                  {
                    id: "is_not_one_of_group_values",
                    label: message({ id: "is_not_one_of_collections" }),
                  },
                ]),
          ]}
          label={<RequiredFieldLabel text={message({ id: "condition" })} />}
          name={`${fieldName}.operator`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue(
              `${fieldName}.data`,
              e.target.value === "is_one_of" ||
                e.target.value === "is_not_one_of"
                ? []
                : {},
            );
          }}
        />
      </Grid>
      {["is_not_one_of", "is_one_of"].indexOf(value.operator) >= 0 && (
        <Grid item xs={12}>
          <SelectInput
            multiple
            displaySearch
            data-test-id="condition-value"
            width="100%"
            items={
              countriesList?.map((country) => ({
                label: country.name,
                id: country.code,
              })) || []
            }
            label={message({ id: "country" })}
            name={`${fieldName}.data`}
            placeholder={message({ id: "country" })}
          />
        </Grid>
      )}
      {["is_one_of_group_values", "is_not_one_of_group_values"].indexOf(
        value.operator,
      ) >= 0 && (
        <Grid item xs={12}>
          <VariableGroupsDropdown
            fieldName={`${fieldName}.data.groupOfValues`}
            data-test-id="condition-value"
            placeholder={message({ id: "chooseFromTheList" })}
            value={value.data?.groupOfValues}
          />
        </Grid>
      )}
    </>
  );
}
